import { ColumnSpecification } from '@rygen/rygen-ui/model';

import i18n from '@/i18n';
import { useLocationGroupStore } from '@/stores/LocationGroup';

export interface OriginLocationGroupColumnRow {
  originLocationGroupIds?: string[];
}

export interface DestinationLocationGroupColumnRow {
  destinationLocationGroupIds?: string[];
}

const renderLocationGroupList = (
  naturalIds: string[] | undefined | null,
): string => {
  const { formatLocationGroupNames } = useLocationGroupStore();
  return formatLocationGroupNames(naturalIds ?? []) || '-';
};

export const ORIGIN_LOCATION_GROUP_COLUMN = new ColumnSpecification({
  field: 'originLocationGroups',
  header: `${i18n.global.t('orders.origin')} ${i18n.global.t('locationGroups.locationGroups', 2)}`,
  body: ({ data }: { data: OriginLocationGroupColumnRow }) =>
    renderLocationGroupList(data.originLocationGroupIds),
});

export const DESTINATION_LOCATION_GROUP_COLUMN = new ColumnSpecification({
  field: 'destinationLocationGroups',
  header: `${i18n.global.t('orders.destination')} ${i18n.global.t('locationGroups.locationGroups', 2)}`,
  body: ({ data }: { data: DestinationLocationGroupColumnRow }) =>
    renderLocationGroupList(data.destinationLocationGroupIds),
});

export interface EsOriginLocationGroupColumnRow {
  origin?: { location?: { locationGroupIds?: string[] } };
}

export interface EsDestinationLocationGroupColumnRow {
  destination?: { location?: { locationGroupIds?: string[] } };
}

export const ES_ORIGIN_LOCATION_GROUP_COLUMN = new ColumnSpecification({
  field: 'originLocationGroups',
  header: `${i18n.global.t('orders.origin')} ${i18n.global.t('locationGroups.locationGroups', 2)}`,
  body: ({ data }: { data: EsOriginLocationGroupColumnRow }) =>
    renderLocationGroupList(data.origin?.location?.locationGroupIds),
});

export const ES_DESTINATION_LOCATION_GROUP_COLUMN = new ColumnSpecification({
  field: 'destinationLocationGroups',
  header: `${i18n.global.t('orders.destination')} ${i18n.global.t('locationGroups.locationGroups', 2)}`,
  body: ({ data }: { data: EsDestinationLocationGroupColumnRow }) =>
    renderLocationGroupList(data.destination?.location?.locationGroupIds),
});
